<template>
  
  <Header></Header>

  <div class="contaier" :class="{hideSidebar: isCollapse}">
    <Sidebar class="sidebar-container" :isCollapse="isCollapse">
      <div
        class="sidebar-togglebtn"
        :class="{collapse: isCollapse}"
        @click="toggleSideBar"
      ><el-icon><Back /></el-icon></div>
    </Sidebar>

    <div class="main-container" id="mainContainer">

      <Navbar v-if="!isIndex" :title="$route.meta.title" ref="nagivaion"></Navbar>

      <!-- 内容区 -->
      <AppMain></AppMain>
    </div>
  </div>
  

  <!-- 新手引导 -->
  <guide></guide>
</template>

<script>
import { ref, watch } from "vue";
import Header from "./components/Header.vue";
import Sidebar from "./components/Sidebar/index.vue";
import Navbar from "./components/Navbar.vue";
import AppMain from "./components/AppMain.vue";
import guide from "./components/guide.vue"

import { useRoute } from "vue-router";
import Cookies from "js-cookie";

export default {
  components: {
    Header,
    Navbar,
    Sidebar,
    AppMain,
    guide
  }, 
  created() {
    // 1: 蓝(默认) 2：绿 3：灰 4: 紫
    document.documentElement.classList.forEach(item => {
      if(item.indexOf("theme_") > -1) {
        document.documentElement.classList.remove(item);
      }
    })
    document.documentElement.classList.add(`theme_${Cookies.get("theme_color")}`);
  },
  setup() {
    const isIndex = ref(false);
    const isCollapse = ref(false);
    const route = useRoute();
    const currPath = route.path;
    if(currPath == '/' || currPath == ''){
      isIndex.value = true;
    }else {
      isIndex.value = false;
    }

    watch(() => route.path, (newVal) => {
      if(newVal == '/' || newVal == ''){
        isIndex.value = true;
      }else {
        isIndex.value = false;
      }
    });
    
    const toggleSideBar = ()=>{
      isCollapse.value = !isCollapse.value
    }
    return { isCollapse, toggleSideBar, isIndex };
  },

};
</script>

<style lang="less" scoped></style>
